export { ExameLocal } from './ExameLocal'
